module.exports = __webpack_public_path__ + "static/img/14000683.ba4c0749.png";